import React from "react";
import { withAppState } from "../../state";
import { withSubtheme } from "../../styles/themes/withSubtheme";
import { redirectTo } from "../../services/navigationService";

import { ModalSettings, withFocusable } from "../../services/visualLibraryService";
import FreeLogo from "../../components/FreeLogo";
import { i18n } from "../../services/i18nService";
import { ButtonStyled } from "./styles/Styled";

import { historyMethods } from "../../utils/historyMethods";
import { routes } from "../../routes";
import { getGlobalButtonInfo } from "../../errors/globalButtons";
import { getSdk } from "../../services/sdkService";

const ButtonFocus = withFocusable(ButtonStyled);

class LoginOrSignup extends React.Component {
  constructor(props) {
    super(props);
    this.goBack = this.goBack.bind(this);
    this.onBack = this.onBack.bind(this);
    this.isRTL = i18n.getDirection() === i18n.directions.RIGHT_TO_LEFT;

    this.buttons = [
      {
        ...getGlobalButtonInfo("no"),
        buttonHandler: () => {
          this.goBack();
        }
      },
      {
        ...getGlobalButtonInfo("yes"),
        buttonHandler: () => getSdk().systemManager.application.exit()
      }
    ];

    this.modalConfig = {
      modalTitle: i18n.get("global.modals.exit.title"),
      modalText: i18n.get("global.modals.exit.text"),
      buttons: this.buttons
    };
  }

  goBack() {
    const { history } = this.props;
    history.replace(history.location.referrer);
  }

  onBack() {
    this.goBack();
    return true;
  }

  componentDidMount() {
    this.props.onRef && this.props.onRef(this);

    const firstButtonFocusPath = getGlobalButtonInfo("no").focusPath;
    this.props.setFocus(firstButtonFocusPath);
  }

  render() {
    return (
      <ModalSettings
        descriptionFontWeight={this.modalConfig.descriptionFontWeight}
        headingText={this.modalConfig.modalTitle}
        mainText={this.modalConfig.modalText}
        // headerIcon={<FreeLogo />}
        isRTL={this.isRTL}
        isSignup={this.modalConfig.isSignup}
      >
        {this.modalConfig.buttons &&
          this.modalConfig.buttons.map((button, i, allButtons) => (
            <ButtonFocus
              label={button.label.toUpperCase()}
              focusPath={button.focusPath}
              dataSnUp={getClosestButtonFocusPath("up", allButtons, i)}
              dataSnDown={getClosestButtonFocusPath("down", allButtons, i)}
              displayBlock={true}
              dataSnLeft={getClosestButtonFocusPath("left", allButtons, i)}
              dataSnRight={getClosestButtonFocusPath("right", allButtons, i)}
              onEnterPress={() => button.buttonHandler()}
              onMouseUp={() => button.buttonHandler()}
              size="medium"
              spacing="xsmall"
              key={button.label}
              isMarginTop={this.modalConfig.isSwitchPlan && i18n.getLocale() === "fr" ? false : true}
              lang={i18n.getLocale()}
              noborder={button?.noborder && button?.noborder}
              customCSS={button?.customCSS}
              isSwitchPlan={this.modalConfig.isSwitchPlan}
              isModalCloseBtn={button.isModalCloseBtn}
              customMarginTop={button.customMarginTop}
              customWidth={button.customWidth}
            />
            // <ButtonFocus
            //   label={button.label.toUpperCase()}
            //   focusPath={button.focusPath}
            //   dataSnUp={getClosestButtonFocusPath("up", allButtons, i)}
            //   dataSnDown={getClosestButtonFocusPath("down", allButtons, i)}
            //   displayBlock={true}
            //   dataSnLeft={getClosestButtonFocusPath("left", allButtons, i)}
            //   dataSnRight={getClosestButtonFocusPath("right", allButtons, i)}
            //   onEnterPress={() => button.buttonHandler()}
            //   onMouseUp={() => button.buttonHandler()}
            //   size="medium"
            //   spacing="xsmall"
            //   key={button.label}
            // />
          ))}
      </ModalSettings>
    );
  }
}

export default withAppState(withSubtheme(LoginOrSignup));

/**
 * For a given button within a list of buttons, this function returns the focus path of the immediately closest button
 * in a given direction. If there is no more buttons in the specified direction, the function will return an empty
 * string, meaning that there is no focusable element in that direction.
 * @param {String} direction  specifies the direction on which the closest button needs to be found. Possible values are
 * "left" or "right".
 * @param {Array} buttonsList The list of buttons to be used to look for the closest item for a given button.
 * @param {Number} index  The index in the array of the button whose closest item in a given direction needs to be
 * found.
 * @return {string} The focus path of the closest button found in the received direction or empty string is no more
 * buttons were present in the mentioned direction.
 */
function getClosestButtonFocusPath(direction, buttonsList, index) {
  const appDirection = i18n.getDirection();
  let newIndex = null;

  const getClosestPreviousButton = () => {
    if (index === 0) {
      return "";
    } else {
      return index - 1;
    }
  };
  const getClosestNextButton = () => {
    if (index === buttonsList.length - 1) {
      return "";
    } else {
      return index + 1;
    }
  };

  if (direction === "up") {
    newIndex = getClosestPreviousButton();
  } else if (direction === "down") {
    newIndex = getClosestNextButton();
  } else {
    if (appDirection === i18n.directions.LEFT_TO_RIGHT) {
      if (direction === "left") {
        newIndex = getClosestPreviousButton();
      } else if (direction === "right") {
        newIndex = getClosestNextButton();
      }
    } else if (appDirection === i18n.directions.RIGHT_TO_LEFT) {
      if (direction === "right") {
        newIndex = getClosestPreviousButton();
      } else if (direction === "left") {
        newIndex = getClosestNextButton();
      }
    }
  }
  return newIndex === "" ? "" : "@" + buttonsList[newIndex].focusPath;
}
